import React from "react";
function createAuthContext() {
  return React.createContext(void 0);
}
export {
  createAuthContext
};
